import { CXCompanyConfigurationAdapter } from '~/services/cx-services/cx-adapters/cx-company-configuration.adapter';

export class CXCompanyConfigurationService extends CXCompanyConfigurationAdapter {}
